import {
  convertFromQueryToNewUiFormat,
  convertFromNewUiToQueryFormat,
  SubFilterErrorKind,
  GenericOccurredOperation,
  FilterKindEnum,
  GlobalFilter,
  RadioTextFilterOperation,
} from '@hotjar/global-filters';
import { cloneDeep } from 'lodash-es';
import { v4 as generateUUID } from 'uuid';

import type { JsonFilters } from '../../../../../store/list/types';

const addErrorFilterToGlobalFilters = (filters: GlobalFilter, errorText: string): void => {
  filters.filterList.push({
    id: generateUUID(),
    kind: FilterKindEnum.Error,
    value: {
      operation: GenericOccurredOperation.OCCURRED,
      subFilters: [
        {
          id: generateUUID(),
          kind: SubFilterErrorKind.TEXT,
          value: {
            operation: RadioTextFilterOperation.CONTAINS,
            value: errorText,
          },
        },
      ],
    },
  });
};

export const generateNavigationLinkToTrends =
  (siteId: number, jsonFilters: JsonFilters) =>
  (errorText: string): string => {
    const targetPathname = `/sites/${siteId}/trends`;
    const filtersInUiFormat = convertFromQueryToNewUiFormat(jsonFilters);
    const clonedFilters = cloneDeep(filtersInUiFormat);

    // Remove existing error filters
    clonedFilters.filterList = clonedFilters.filterList.filter(
      (filter) => filter.kind !== FilterKindEnum.Error,
    );

    addErrorFilterToGlobalFilters(clonedFilters, errorText);

    const stringFilters = JSON.stringify([convertFromNewUiToQueryFormat(clonedFilters)]);
    const keyValuePairList: [string, string][] = [];
    keyValuePairList.push(['filter-series', stringFilters]);
    const searchParams = new URLSearchParams(keyValuePairList);

    return new URL(`${targetPathname}?${searchParams}`, window.location.href).toString();
  };
